import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ServicioService } from '@app/core/service/servicio.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ListItem } from 'ng-multiselect-dropdown/multiselect.model';
import { Subject } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap
} from 'rxjs/operators';

@Component({
  selector: 'app-service-forms',
  templateUrl: './service-forms.component.html',
  styleUrls: ['./service-forms.component.css']
})
export class ServiceFormsComponent implements OnInit, OnDestroy {
  formGroup: FormGroup;
  @Output() formReady = new EventEmitter<any>();
  subject = new Subject();

  serviciosArray: any[];
  dropdownSettingsServicio: IDropdownSettings = {};
  private subjectSearchServicio = new Subject<any>();
  private subjectSearchServicio$ = this.subjectSearchServicio.asObservable();
  selectedItemsServicio: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    public servicioService: ServicioService
  ) {
    this.formGroup = this.formBuilder.group({
      servicios: this.formBuilder.array([])
    });
    this.dropdownSettingsServicio = {
      singleSelection: false,
      idField: 'servicio_id',
      textField: 'nombre',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      searchPlaceholderText: 'Buscar ...',
      itemsShowLimit: 8,
      allowSearchFilter: true,
      limitSelection: 4,
      noDataAvailablePlaceholderText: 'No llegaron a Encontrar datos...',
      allowRemoteDataSearch: true
    };
  }

  ngOnInit(): void {
    this.findfirstService();
    this.subjectSearchServicio.next('');
  }

  ngOnDestroy(): void {
    //   this.subject.unsubscribe();
  }

  crearServicio(): FormGroup {
    return this.formBuilder.group({
      servicio_id: '',
      nombre: '',
      precio: ['', [Validators.required]]
    });
  }

  get servicios(): FormArray {
    return this.formGroup.get('servicios') as FormArray;
  }

  // select service
  onItemSelectService(item: any) {
    console.log('selctItem', item);
    const control = <FormArray>this.formGroup.controls['servicios'];
    control.push(this.crearServicio());
    this.formGroup.patchValue({ servicios: this.selectedItemsServicio });
    console.log('selectedItemsServicio', this.selectedItemsServicio);
    console.log(this.formGroup.value);
    // this.onChangesInstructivosCopy();
  }

  onDeSelectService(item: any) {
    console.log(item);
    const control = <FormArray>this.formGroup.controls['servicios'];
    console.log('control', control);
    for (let i = 0; i < control.controls.length; i++) {
      if (item.servicio_id === control.controls[i].get('servicio_id').value) {
        (<FormArray>this.formGroup.controls['servicios']).removeAt(i);
      }
    }
    console.log(this.selectedItemsServicio);
    console.log(this.formGroup.value);
  }

  onChangeFilterService(event: ListItem) {
    this.subjectSearchServicio.next(event);
  }

  findfirstService() {
    this.subjectSearchServicio$
      .pipe(
        debounceTime(400),
        distinctUntilChanged(),
        tap(query => console.log(`texto de busqueda a la api: ${query}`)),
        switchMap(value => this.servicioService.getAll(value))
      )
      .subscribe((res: any) => {
        this.serviciosArray = res.data;
      });
  }
}
